<template>
  <div>
    <div style="min-width: 1366px; background: #ffffff">
      <el-container>
        <el-container>
          <div
            class="navWrap"
            style="
              background: #ffffff;
              box-shadow: 0px 0px 20px 0px rgb(130 127 127 / 21%);
              border-radius: 10px;
              margin: 20px 0px 20px 20px;
            "
          >
            <el-button
              style="
                width: 132px;
                height: 36px;
                background: #FF4D01;
                border-radius: 5px;
                border-color: #FF4D01;
                margin-bottom: 28px;
              "
              type="primary"
              icon="el-icon-search"
              @click="pathIndex()"
              >查价下单</el-button
            >
            <el-aside width="200px" style="overflow: hidden;flex:1;border-radius: inherit;">
              <el-menu
                :router="routerType"
                :default-active="path"
                unique-opened
                class="el-menu-vertical-demo"
                style="width: 219px;overflow-y: scroll;height: 100%;border-radius: inherit;"
                @open="handleOpen"
                @close="handleClose"
                @select="pathTo"
              >
                <el-submenu
                  :index="index + 1 + ''"
                  v-for="(item, index) in navList"
                  :key="index"
                >
                  <template slot="title">
                    <i :class="item.icon"></i>
                    <span
                      style="
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        color: #333333;
                      "
                      >{{ item.name }}</span
                    >
                  </template>
                  <el-menu-item-group
                    v-for="(_item, _index) in item.nextNodes"
                    :key="_index"
                  >
                    <el-menu-item
                      :index="_item.code"
                      @click="clickMenu(_item)"
                      >{{ _item.name }}</el-menu-item
                    >
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-aside>
          </div>
          <el-container>
            <el-main>
              <el-header>
                <elTabs></elTabs>
              </el-header>
              <router-view />
            </el-main>
          </el-container>
        </el-container>
      </el-container>
    </div>
    <!-- 电商小包弹框 -->
    <!-- <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleCloseDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <span>
        <div class="small-big">
          <p>{{ urlAddress }}</p>
          <a :href="urlAddress">电商小包</a>
          <p>为了提供更好电商小包服务,您将被跳转到IES小包系统</p>
        </div>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import navlistBus from "./components/navlistBus.js";
import elTabs from "../../../common/Tabswrap/el_tabs.vue";
export default {
  components: {
    elTabs,
  },
  data() {
    return {
      dialogVisible: false, // 电商小包弹框
      noTpath: null,
      path: "",
      routerType: true,
      navList: [],
      name: "",
      urlAddress: "",
    };
  },
  watch: {
    $route: "onRouteChanged",
  },
  methods: {
    handleCloseDialog(){
      this.dialogVisible = false
    },
    clickMenu(item) {
      console.log("itemMenu: ", item);
      // if (item.name == "电商小包") {
      //   // 跳转到亦邦IES系统
      //   // let url = ""
      //   // IES测试地址
      //   this.name = "电商小包";
      //   this.axios
      //     .get("/api/user/cititrans/login")
      //     .then((res) => {
      //       if (res.data.code == 200) {
      //         let token = res.data.data.token;
      //         let linkUrl = res.data.data.linkUrl;

      //         // 物流产品业务类型IBC、DBC 跳
      //         // http://ioms.cititrans.com/order-create/orders-forward?token=xxx&productkindId=xxx
      //         // 物流产品业务类型ICB、DCB 跳
      //         // http://ioms.cititrans.com/order-create/orders-reverse?token=xxx&productkindId=xxx
      //         // 物流产品业务类型ICC、DCC 跳
      //         // http://ioms.cititrans.com/order-create/orders-personal?token=xxx&productkindId=xxx
      //         let url = "";
      //         url = `${linkUrl}/order-create/orders-forward?token=${token}`;
      //         console.log("url---", url);
      //         this.urlAddress = url
      //         // window.open(url);
      //         this.dialogVisible = true
      //       } else {
      //         // data.message
      //         this.$message({
      //           type: "error",
      //           message: res.data.message,
      //         });
      //       }
      //     })
      //     .catch((res) => {});

        // let url = "http://ioms.cititrans.com.cn/order-create/orders-personal?token=eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJJVEQwMDMiLCJjcmVhdGVkIjoxNjQyNDg2OTgzMTMzLCJleHAiOjE2NDMwOTE3ODN9.qcLAfqvCl80R-D0maFWRb2xSG3RwJHXmNMxtmq5bIIQ1K0Tprca_gBEK7erxar1p5n_5pyTaKQ12zwZGalAK1Q&productkindId=918202896689438720"
        // window.open(url)
      // } else {
        this.$store.commit("mutationSelectTags", item);
      // }
    },
    hasChildren(children) {},
    onRouteChanged() {
      this.$store.commit("changeactive", null)
      this.path = this.$route.path;
    },
    pathIndex() {
      this.$router.push({
        path: "/",
      });
      this.$store.commit("changeSetType", false);
      this.$store.commit("changeactive", 1);
    },
    handleOpen(key, keyPath) {
      // console.log('handleOpen');
      // console.log(key);
    },
    handleClose(key, keyPath) {},
    pathTo(index, indexPath) {
      console.log("index: ", index);
      this.noTpath = index;
      console.log("999", this.name);
      if (!index) {
        // if (this.name == "电商小包") {
        //   return;
        // } else {
        //   return this.$message({
        //     message: "当前业务暂未开放，敬请期待。。。",
        //     type: "warning",
        //   });
        // }
      }
    },
  },
  created() {
    this.onRouteChanged();
    let user = this.sessionGetUserInfo();
    this.navList = user.authorities;
    let authList = [];
    // authList.push("/");
    // authList.push("/");
    // authList.push(
    //   "/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow"
    // );
    if (this.navList.length && this.navList.length > 0) {
      this.navList.forEach((v) => {
        v.nextNodes.forEach((v2) => {
          authList.push(v2.code);
        });
      });
    }
    if (authList.length > 0) {
      sessionStorage.setItem("authList", JSON.stringify(authList));
    }
  },
  mounted() {
    navlistBus.$on("navlistToindex", (data) => {
      console.log("navlistBus: ", data);
      this.navList = data;
    });
  },
};
</script>
<style scoped>
.navWrap >>> .el-menu-item-group__title {
  padding: 0 !important;
}
.navWrap >>> .el-menu {
  border-right: none;
}
.navWrap >>> .el-submenu__title {
  padding: 0 50px;
}
.navWrap {
  padding-top: 28px;
  box-sizing: border-box;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
    0 2px 4px 0 rgba(232, 237, 250, 0.5);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: column;
  /* max-height: calc(100vh - 80px - 20px - 20px); */
}
.el-footer {
  text-align: center;
}
.el-header {
  height: auto !important;
  padding: 0 !important;
}
.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  /* text-align: center; */
}

body > .el-container {
  margin-bottom: 40px;
  height: 100%;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/Personalindex.vue